// src/GlobalComponents/StyledButtonBase.js
import React from 'react';
import PropTypes from 'prop-types'; // Import prop-types
import { Button, useColorModeValue } from '@chakra-ui/react';

const StyledButtonBase = ({ children, bg, color, borderColor, isDisabled, size, ...props }) => {
  const buttonBg = useColorModeValue('rcBrand.evergreen', 'rcBrand.forest');
  const textColor = useColorModeValue('white', 'white');
  const defaultBorderColor = useColorModeValue('rcBrand.evergreen', 'rcBrand.evergreen');

  return (
    <Button
      bg={bg || buttonBg}
      color={color || textColor}
      borderColor={buttonBg|| defaultBorderColor}
      isDisabled={isDisabled}
      _hover={{ bg: 'transparent', color: {textColor} }} 
      _active={{ bg: '#00853E' }} 
      borderRadius="md"
      borderWidth={2}
      size={size || 'md'}
      boxShadow="sm"
      {...props}
    >
      {children}
    </Button>
  );
};

StyledButtonBase.propTypes = {
  bg: PropTypes.string, // Expecting a string for background color (hex, color name, etc.)
  color: PropTypes.string, // Expecting a string for text color
  borderColor: PropTypes.string, // Expecting a string for border color
  isDisabled: PropTypes.bool, // Expecting a boolean for disabled state
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl', '3xl']), // Expecting a string for button size
  children: PropTypes.node.isRequired, // Expecting children nodes (e.g., text, elements)
};

StyledButtonBase.defaultProps = {
  isDisabled: false, // Default to not disabled
};

export default StyledButtonBase;
